import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from '@mui/material';
import {
  ButtonContain,
  Card,
  CardContain,
  CardCustomList,
  CardFooter,
  CardTitle,
  CustomButtonContain,
  CustomButtonContainMoM,
  CardFooterMoM,
  TableContain,
  TabsContain
} from '../../style/Home'
import Grid from '@mui/material/Grid';
import Filter from '../../Components/filters';
import DoughnutChart from '../../Components/AM/charts/Chart';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Colors } from '../../style/theme';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetDashboardData, GetBmvrDashboardData} from '../../services/dashboardService';
import { resetFilter } from "../../features/filterSlice";
import { toast, ToastContainer  } from 'react-toastify';
import PopUpModal from '../../Components/Modal/PopUpModal';
import { UserPopUpNotification } from '../../services/popUpService';
import moment from 'moment';
function Home() {

  const [value, setValue] = useState('MVRTabs');
  const [isSticky, setIsSticky] = useState(false); // To track scroll position
  const [filterValues, setFilterValues] = useState({});
  const [dashboardData, setDashboardData] = useState({})
  const [bMvrDashboardData, setBmvrDashboardData] = useState({});
  const [loader, setLoader] = useState(false)
  const filtersValue = useSelector((state) => state.filterData);
  const [resetTrigger, setResetTrigger] = useState(Date.now());
  const dispatch = useDispatch();
  const [isDispatched, setIsDispatched] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [isBmvrApiCalled, setIsBmvrApiCalled] = useState(false);
  
  // popUp Work
  const [isPopupModalOpen, setIsPopupModalOpen] = useState(false);
  const [popUpData, setPopUpData] = useState([]);

  const closePopupModal = () => {
    setIsPopupModalOpen(false);
  };

  const fetchPopUpData = async () => {
    try {
      const response = await UserPopUpNotification();
      if (response.success) {

        const currentStamp = moment().format('YYYY-MM-DD HH:mm:ss');
        localStorage.setItem("lastPopUpAt", currentStamp)

        const notificationArray = response?.data?.notifications ?? [] 

        if(!notificationArray.length) return;

        setPopUpData(notificationArray);
        setIsPopupModalOpen(true)
        
      } else {
        toast.error("No notifications found.");
      }
    } catch (error) {
      toast.error("Error Fetching Data",error);
      
    }
  };

  useEffect(() => {
    const lastPopUpAt = localStorage.getItem("lastPopUpAt");

    if (!lastPopUpAt) {
      fetchPopUpData();
      return;
    }

    const lastPopUpAtStamp = moment(lastPopUpAt, "YYYY-MM-DD HH:mm:ss");
    const currentStamp = moment();
    const hoursDifference = currentStamp.diff(lastPopUpAtStamp, "minutes");

    if (hoursDifference < 180) return;

    fetchPopUpData();
  }, []);
  
  useEffect(() => {
    dispatch(resetFilter());
    setIsDispatched(true)
  }, [dispatch]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true); // Add 'sticky' class when scroll > 56px
      } else {
        setIsSticky(false); // Remove 'sticky' class
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Define the second table data with colors
  const secondTableData = [
    { label: "Total MoM", color: "blue" },
    { label: "Opened MoM", color: "#ff4500" },
    { label: "Completed MoM", color: "#71BC78" },
    { label: "Reopened MoM", color: "#f9b94b" },
    { label: "Closed MoM", color: "#009000" },
  ];

  // Prepare chart data (without filtering)
  const MoMchart = {
    labels: secondTableData.map((item) => item.label),
    datasets: [
      {
        data: (() => {
          const {totalMom, openMom, closedMom, completedMom, reopenedMom} = dashboardData?.momStatus ?? {}
          const ordered = [totalMom, openMom, completedMom, reopenedMom, closedMom]
          return ordered.filter(Boolean)
        })(),
        backgroundColor: secondTableData.map((item) => item.color),
        hoverBackgroundColor: secondTableData.map((item) => item.color),
      },
    ],
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {

            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
    },
  };


  // define chart strucuture for mom data
  const bmvrMomChart = {
    labels: secondTableData.map((item) => item.label),
    datasets: [
      {
        data: (() => {
          const {totalMom, openMom, closedMom, completedMom, reopenedMom} = bMvrDashboardData?.bmomStatus ?? {}
          const ordered = [totalMom, openMom, completedMom, reopenedMom, closedMom]
          console.log(ordered)
          return ordered.filter(Boolean)
        })(),
        backgroundColor: secondTableData.map((item) => item.color),
        hoverBackgroundColor: secondTableData.map((item) => item.color),
      },
    ],
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {

            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
    },
  }

  // Excalation Table

  const excalationTableData = [
    { label: "Total Excalation", color: "blue" },
    { label: "Excalation to AI", color: "#71BC78" },
    { label: "Excalation to ZM", color: "#f9b94b" },
    { label: "Excalation to RM", color: "#ff4500" },
  ];

  const excalationChart = {
    labels: excalationTableData.map((item) => item.label),
    datasets: [
      {
        data: (() => {
          const values = dashboardData?.escStatus
            ? Object.values(dashboardData?.escStatus)
            : [];
          values.pop();
          return values;
        })(),
        backgroundColor: excalationTableData.map((item) => item.color),
        hoverBackgroundColor: excalationTableData.map((item) => item.color),
      },
    ],
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
    },
  };

  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev, // Keep previous values
      [filterKey]: value, // Update the specific field
    }));
  };

  const getDashboardData = async () => {
    try {
      setLoader(true)
      const payload = filtersValue
      const res = await GetDashboardData({ payload: payload })
      if (res.success) {
        setIsApiCalled(true);
        setDashboardData(res.data);
      }
    } catch (error) {
      console.log("error: ", error);
      if (error.code === "ERR_NETWORK") {
        toast.error("Network error");
      }
    } finally {
      setLoader(false);
    }
  }

  const getBmvrDashboardData = async () => {
    try{
      setLoader(true)
      const payload = filtersValue
      const res = await GetBmvrDashboardData({payload: payload})
      if (res.success){
        setIsBmvrApiCalled(true)
        setBmvrDashboardData(res.data);
      }
    }catch(error){
      console.log('Error on loading bmvr dashboard data: ', error);
    }finally{
      setLoader(false);
    }
  }

  const handleSearch = async () => {
    if(value === "MVRTabs"){
      await getDashboardData()
    }else{
      await getBmvrDashboardData();
    }
  }


  useEffect(() => {
    if (isDispatched && value === "MVRTabs" && !isApiCalled) {
      getDashboardData();
    }
    if (isDispatched && value === "BMVRTabs" && !isBmvrApiCalled){
      getBmvrDashboardData();
    }
  }, [resetTrigger, isDispatched, value])


  // chart data start
  const MVRchart = {
    labels: [
      "Total AMD",
      "Submitted By AM",  
      "Accepted By ZM",
      "Reconsidered By ZM",
      "Pending At AM",
    ],
    datasets: [
      {
        data: (() => {
          const values = dashboardData?.mvrStatus ? Object.values(dashboardData?.mvrStatus) : [];
          values.pop(); // Remove the last value
          return values;
        })(),
        backgroundColor: [
          Colors.total,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderColor: [
          Colors.total,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderWidth: 1,
      },
    ],
  };

  // bmvr chart
  const bmvrChart = {
    labels: [
      "Total AMD",
      "Submitted By AM",  
      "Accepted By ZM",
      "Reconsidered By ZM",
      "Pending At AM",
    ],
    datasets: [
      {
        data: (() => {
          const values = bMvrDashboardData?.bmvrStatus ? Object.values(bMvrDashboardData?.bmvrStatus) : [];
          values.pop(); // Remove the last value
          return values;
        })(),
        backgroundColor: [
          Colors.total,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderColor: [
          Colors.total,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderWidth: 1,
      },
    ],
  };

  const QVRchart = {
    labels: [
      "Total AMD",
      "Eligible AMD",
      "Visit Plan",
      "Evaluation By AM",
      "Reconsideration Request",
      "Accepted By AMD",
      "Avrage Score",
    ],
    datasets: [
      {
        data: [6, 1, 1, 1, 1, 1, 1],
        backgroundColor: [
          Colors.total,
          Colors.submitted,
          Colors.pending,
          Colors.total,
          Colors.reconsidertion,
          Colors.accepted,
          Colors.pending,
        ],
        borderColor: [
          Colors.total,
          Colors.submitted,
          Colors.pending,
          Colors.total,
          Colors.reconsidertion,
          Colors.accepted,
          Colors.pending,
        ],
        borderWidth: 1,
      },
    ],
  };
  // chart data end


  const handleReset = () => {
    dispatch(resetFilter())
    if (value === "MVRTabs"){
      setIsApiCalled(false)
    }else {
      setIsBmvrApiCalled(false)
    }
    setResetTrigger(Date.now())
    setTimeout(() => setResetTrigger(false), 0)
  }

  return (
    <>
      <TabsContain>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs example"
          className={`HomeTabs ${isSticky ? "StickyShadow" : ""}`}
        >
          <Tab label="MVR" value="MVRTabs" />
          {/* <Tab label="QVR" value="QVRTabs" /> */}
          <Tab label="BMVR" value="BMVRTabs" />
        </Tabs>
      </TabsContain>

      {isPopupModalOpen && <PopUpModal onClose={closePopupModal} data={popUpData}/>}
          <ToastContainer position="top-right" autoClose={5000} />
     
      {value === "MVRTabs" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter onFilterChange={handleFilterChange} reset={resetTrigger}></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button onClick={handleSearch} className="SearchButton">Search</button>
                    <button onClick={handleReset} className="ResetButton">Reset</button>
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain mt={2}>
            <CardTitle variant="h4">MVR Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total AMD :
                      <span className="StatusCount total">
                        {dashboardData?.mvrStatus?.total}
                      </span>
                    </li>
                    <li>
                      Pending At AM :
                      <span className="StatusCount pending">
                        {dashboardData?.mvrStatus?.pending}
                      </span>
                    </li>
                    <li>
                      Reconsidered By ZM :
                      <span className="StatusCount reconsidertion">
                        {dashboardData?.mvrStatus?.reconsidered}
                      </span>
                    </li>
                    <li>
                      Accepted By ZM :
                      <span className="StatusCount accepted">
                        {dashboardData?.mvrStatus?.accepted}
                      </span>
                    </li>
                    <li>
                      Submitted By AM :
                      <span className="StatusCount submitted">
                        {dashboardData?.mvrStatus?.submittedByAm}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={MVRchart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooter>
              <div>
                <p>
                  {" "}
                  Total MVR Submitted :{" "}
                  <span className="MVRCount">
                    {dashboardData?.mvrStatus?.totalSubmitted}
                  </span>
                </p>
              </div>

              <CustomButtonContain>
                <Link to="/amdstatus">
                  <button className="Pointer">
                    AMD Wise Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>

          {/* Second Table */}

          <CardContain mt={2}>
            <CardTitle variant="h4">MoM Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "blue" }}
                      >
                        {dashboardData?.momStatus?.totalMom}
                      </span>
                    </li>
                    <li>
                      Opened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {dashboardData?.momStatus?.openMom}
                      </span>
                    </li>
                    <li>
                      Completed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#71BC78" }}
                      >
                        {dashboardData?.momStatus?.completedMom}
                      </span>
                    </li>
                    <li>
                      Reopened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {dashboardData?.momStatus?.reopenedMom}
                      </span>
                    </li>
                    <li>
                      Closed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#009000" }}
                      >
                        {dashboardData?.momStatus?.closedMom}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={MoMchart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooterMoM>
              <CustomButtonContainMoM>
                <Link to="/momstatus">
                  <button className="Pointer">
                    MoM Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContainMoM>
            </CardFooterMoM>
          </CardContain>


          {/* Third Table */}

          {/* <CardContain mt={2}>
            <CardTitle variant="h4">Escalation Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total Escalation :
                      <span
                        className="StatusCount"
                        style={{ color: "blue" }}
                      >
                        {dashboardData?.escStatus?.totalEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to AM :
                      <span
                        className="StatusCount"
                        style={{ color: "#71BC78" }}
                      >
                        {dashboardData?.escStatus?.amEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to ZM :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {dashboardData?.escStatus?.zmEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to RM :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {dashboardData?.escStatus?.rmEsc}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={excalationChart} />
                </Grid>
              </Grid>
            </Card>


          </CardContain> */}
        </>
      )}
       {value === "BMVRTabs" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter onFilterChange={handleFilterChange} reset={resetTrigger} showBmvrFrequency={true}></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button onClick={handleSearch} className="SearchButton">Search</button>
                    <button onClick={handleReset} className="ResetButton">Reset</button>
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain mt={2}>
            <CardTitle variant="h4">BMVR Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total AMD :
                      <span className="StatusCount total">
                        {bMvrDashboardData?.bmvrStatus?.total}
                      </span>
                    </li>
                    <li>
                      Pending At AMD :
                      <span className="StatusCount pending">
                        {bMvrDashboardData?.bmvrStatus?.pending}
                      </span>
                    </li>
                    <li>
                      Reconsidered By AM :
                      <span className="StatusCount reconsidertion">
                        {bMvrDashboardData?.bmvrStatus?.reconsidered}
                      </span>
                    </li>
                    <li>
                      Accepted By AM :
                      <span className="StatusCount accepted">
                        {bMvrDashboardData?.bmvrStatus?.accepted}
                      </span>
                    </li>
                    <li>
                      Submitted By AMD :
                      <span className="StatusCount submitted">
                        {bMvrDashboardData?.bmvrStatus?.submittedByAm}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={bmvrChart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooter>
              <div>
                <p>
                  {" "}
                  Total BMVR Submitted :{" "}
                  <span className="MVRCount">
                    {bMvrDashboardData?.bmvrStatus?.totalSubmitted}
                  </span>
                </p>
              </div>

              <CustomButtonContain>
                <Link to="/amdstatus" state={{currentSelectedTab : value}}>
                  <button className="Pointer">
                    AMD Wise Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>

          {/* Second Table */}

          <CardContain mt={2}>
            <CardTitle variant="h4">MoM Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "blue" }}
                      >
                        {bMvrDashboardData?.bmomStatus?.totalMom}
                      </span>
                    </li>
                    <li>
                      Opened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {bMvrDashboardData?.bmomStatus?.openMom}
                      </span>
                    </li>
                    <li>
                      Completed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#71BC78" }}
                      >
                        {bMvrDashboardData?.bmomStatus?.completedMom}
                      </span>
                    </li>
                    <li>
                      Reopened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {bMvrDashboardData?.bmomStatus?.reopenedMom}
                      </span>
                    </li>
                    <li>
                      Closed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#009000" }}
                      >
                        {bMvrDashboardData?.bmomStatus?.closedMom}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={bmvrMomChart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooterMoM>
              <CustomButtonContainMoM>
                <Link to="/momstatus" state={{currentSwitchedTab: value}}>
                  <button className="Pointer">
                    MoM Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContainMoM>
            </CardFooterMoM>
          </CardContain>


          {/* Third Table */}

          {/* <CardContain mt={2}>
            <CardTitle variant="h4">Escalation Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total Escalation :
                      <span
                        className="StatusCount"
                        style={{ color: "blue" }}
                      >
                        {dashboardData?.escStatus?.totalEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to AM :
                      <span
                        className="StatusCount"
                        style={{ color: "#71BC78" }}
                      >
                        {dashboardData?.escStatus?.amEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to ZM :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {dashboardData?.escStatus?.zmEsc}
                      </span>
                    </li>
                    <li>
                      Escalation to RM :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {dashboardData?.escStatus?.rmEsc}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={excalationChart} />
                </Grid>
              </Grid>
            </Card>


          </CardContain> */}
        </>
      )}
      {/* {value === "QVRTabs" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  filters={filtersData}
                  onFilterChange={handleFilterChange}
                ></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button className="SearchButton">Search</button>
                    <button className="ResetButton">Reset</button>
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain mt={2}>
            <CardTitle variant="h4">QVR Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total AMD :<span className="StatusCount total">6</span>
                    </li>
                    <li>
                      Eligible AMD :
                      <span className="StatusCount submitted">1</span>
                    </li>
                    <li>
                      Visit Plan :<span className="StatusCount pending">1</span>
                    </li>
                    <li>
                      Evaluation by AM :
                      <span className="StatusCount total">1</span>
                    </li>
                    <li>
                      Reconsideration Request :
                      <span className="StatusCount reconsidertion">1</span>
                    </li>
                    <li>
                      Accepted by AMD :
                      <span className="StatusCount accepted">1</span>
                    </li>
                    <li>
                      Avrage Score :
                      <span className="StatusCount pending">1</span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={QVRchart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooter>
              <div>
                <p> Scores of AMDs who have accepted the evaluaton</p>
              </div>

              <CustomButtonContain>
                <button>
                  AMD Evaluation Status <KeyboardDoubleArrowRightIcon />
                </button>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>
          <CardContain mt={2}>
            <TableContain>
              <table className="table">
                <thead>
                  <tr className="TableTitle">
                    <th colSpan={7}>
                      <h4>MoM Status</h4>
                    </th>
                  </tr>
                  <tr>
                    <th>Total Points</th>
                    <th>Open Points</th>
                    <th>Completed By AMD</th>
                    <th>Completed By AM</th>
                    <th>Escalated To AM</th>
                    <th>Escalated To ZM</th>
                    <th>Escalated To RM</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>6</td>
                    <td>6</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>
            </TableContain>
            <CardFooter>
              <div>
                <p style={{ visibility: "hidden" }}>
                  {" "}
                  Carry <span className="MVRCount"></span>
                </p>
              </div>

              <CustomButtonContain>
                <button>
                  QVR MoM Status <KeyboardDoubleArrowRightIcon />
                </button>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>
        </>
      )} */}
    </>
  );
}

export default Home;
